<template>
    <div>
        <v-snackbar @input="ocultar($event)" :value="value" v-if="!dialogo" :color="color">
            {{ datos.txt }}
            <v-btn dark flat  @click.native="ocultar(false)" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-dialog @input="ocultar($event)" :value="value" v-if="dialogo" persistent max-width="500" scrollable>
            <v-card>
                <v-card-title class="headline">Error de Validación</v-card-title>
                <v-card-text>
                    <v-list  two-line>
                        <template  v-for="(v,k) in datos.errores">
                            <v-list-tile>
                                <v-list-tile-title>
                                    <span v-if="!v.isArray">{{ v }}</span>
                                    <span v-else v-for="d in v">{{ d }} | </span>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.native="ocultar(false)">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: ['value', 'datos'],
        name: "errores",
        methods: {
            ocultar(valor) {
                this.$emit('input', valor)
            }
        },
        computed: {
            dialogo() {
                if (this.datos.errores) {
                    return true
                } else {
                    return false
                }
            },
            color() {
                if (this.datos.tipo === 'error' || this.datos.tipo === 2 ) {
                    return 'red';
                }
                if (this.datos.tipo === 'ok' || this.datos.tipo === 1 || this.datos.tipo === 'success') {
                    return 'green'
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Errores.vue